export default __webpack_public_path__ + "static/media/mode-6.41bc4e90.svg";